import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
    START_LOADING,
    STOP_LOADING,
    GET_DEPARTMETMAP_ALL,
    GET_ALL_UNIT_REVIEWER,
    UPDATE_DEPARTMETMAP_MODAL,
    ERROR_DEPARTMENTMAP_FAIL,
    DEPARTMETMAP_SUCCESS,

    UPDATE_UNIT_REVIEWER_MODAL,
    ERROR_UNIT_REVIEWER_FAIL,
    UNIT_REVIEWER_SUCCESS
} 
from '../actions/actionTypes';

export function getAllDepartmentMapAction() {
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
                method: "get",
                url: `${AppSettings.apiUrl}/api/User/GetAllDepartmentMap`,
               
            })

            promise.then(response => {
                dispatch({
                    type: GET_DEPARTMETMAP_ALL,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function getAllUnitReviewerAction(unit_code) {
    return function (dispatch) {
        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: {...authHeader(),'Pragma': 'no-cache'},
                method: "post",
                url: `${AppSettings.apiUrl}/api/User/GetAllUnitReviewer`,
                params: {
                  unit_code : unit_code
              }
            })

            promise.then(response => {
                dispatch({
                    type: GET_ALL_UNIT_REVIEWER,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}

export function updatedepartmentMapModalAction(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_DEPARTMETMAP_MODAL,
            data: data
        });
    }
  }
  
  export function createDeartmentMapAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/AddDeartmentMap`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
  
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: DEPARTMETMAP_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_DEPARTMENTMAP_FAIL,
              payload: returnMessage
            });
          }
  
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }
  
  export function updateDeartmentMapAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/UpdateDepartmentMap`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: DEPARTMETMAP_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_DEPARTMENTMAP_FAIL,
              payload: returnMessage
            });
          }
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }

  export function deleteDepartmentMapAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/DeleteDepartmentMap`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: DEPARTMETMAP_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_DEPARTMENTMAP_FAIL,
              payload: returnMessage
            });
          }
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }

  export function updateUnitReviewerModalAction(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_UNIT_REVIEWER_MODAL,
            data: data
        });
    }
  }

  export function createUnitReviewerAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/AddUnitReviewer`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
  
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: UNIT_REVIEWER_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_UNIT_REVIEWER_FAIL,
              payload: returnMessage
            });
          }
  
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }
  
  export function updateUnitReviewerAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/UpdateUnitReviewer`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: UNIT_REVIEWER_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_UNIT_REVIEWER_FAIL,
              payload: returnMessage
            });
          }
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }

  export function deleteUnitReviewerAction(data) {
    return function (dispatch) {
      try {
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/User/DeleteUnitReviewer`,
          data: data
        })
  
        promise.then(response => {
          let isSuccess = response.data.isSuccess === true
          let returnMessage = response.data.returnMessage
          if (isSuccess) {
            dispatch({
              type: STOP_LOADING
            })
            dispatch({
              type: UNIT_REVIEWER_SUCCESS
            })
          } else {
            dispatch({
              type: ERROR_UNIT_REVIEWER_FAIL,
              payload: returnMessage
            });
          }
        }
        );
  
        return promise
      } catch (error) {
      }
    }
  }